// 8-character correlation id shown in the toast and logged with the error.
// `toString(36).slice(2, 10)` can come out shorter for small randoms, hence padEnd.
export const newErrorId = (): string =>
  Math.random().toString(36).slice(2, 10).padEnd(8, '0').toUpperCase();
